import api from '../../utils/axios';

export const walletService = {
  getWalletDetails: async (userType, userId) => {
    const response = await api.get(`/wallet/${userType}/${userId}`);
    return response.data;
  },
  requestRedemption: async (data) => {
    const response = await api.post('/wallet/redeem', data);
    return response.data;
  },
  getAgentBookings: async () => {
    const response = await api.get('/agent/bookings');
    return response.data;
  }
};
